/* sb-qa-qty.js — aantal-stepper in de quick-add modal (−/+). 250 g-koffie start op 2 (stap 2),
   zodat de klant meteen een geldig aantal kan toevoegen (de Quantity Limit-app dwingt min 2 af).
   Gedelegeerd op document → werkt voor alle productkaarten, ook dynamisch. */
(function () {
  if (window.__sbQaQty) return;
  window.__sbQaQty = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sb-qa-dec],[data-sb-qa-inc]');
    if (!btn) return;
    var form = btn.closest('.sb-qa__form');
    if (!form) return;
    var input = form.querySelector('[data-sb-qa-qty]');
    if (!input) return;
    var step = parseInt(input.step, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var cur = parseInt(input.value, 10) || min;
    input.value = btn.hasAttribute('data-sb-qa-inc') ? cur + step : Math.max(min, cur - step);
  });
})();
